import {
  FETCH_SCORES_REQUEST,
  SAVE_SCORE_REQUEST,
  CHANGE_SCORE_STATUS_REQUEST,
} from "./actionTypes";

export const fetchScores = (unitId) => ({
  type: FETCH_SCORES_REQUEST,
  payload: { unitId }
});

export const saveScore = (data) => ({
  type: SAVE_SCORE_REQUEST,
  payload: data,
});

export const changeScoreStatus = (payload) => ({
  type: CHANGE_SCORE_STATUS_REQUEST,
  payload,
});
